import SearchOffIcon from "@mui/icons-material/SearchOff";
import { Stack, Typography } from "@mui/material";

/**
 * Displays a message when no clause checklists are found.
 */
export const EmptyClauseChecklistsState = () => {
    return (
        <Stack justifyContent="center" alignItems="center" width="100%" py={4}>
            <SearchOffIcon
                sx={{ fontSize: 128, opacity: 0.4, mb: 1 }}
                color="primary"
            />
            <Typography variant="h6" fontWeight={500}>
                No clause checklists found
            </Typography>
        </Stack>
    );
};
